import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faClock, 
  faBus, 
  faTicketAlt,
  faArrowRight,
  faCalendarAlt,
  faUsers,
  faMapMarkerAlt,
  faInfoCircle,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import Footer from '../../Footer/Footer';
import ParallaxBanner from '../../common/Parralax-banner';

// Import images
import castleImage from '../../../assets/castle2.png';
import busTourImage from '../../../assets/gardens.png';
import castleTourImage from '../../../assets/generalTour.webp';
import banner from '../../../assets/banner/tourBan.webp';

const ToursContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.offWhite};
  padding-top: 120px; 
`;

const ContentContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 4rem 2rem;
  
  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
  }
`;

const NewsletterBadge = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.colors.accent}, #d4af37);
  color: white;
  padding: 1rem 2rem;
  border-radius: 25px;
  text-align: center;
  margin: 0 auto 2rem;
  max-width: 400px;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;
  text-align: center;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: ${props => props.theme.colors.accent};
    margin: 1rem auto 0;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const IntroText = styled.p`
  font-family: ${props => props.theme.fonts.main};
  font-size: 1.2rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.primary};
  max-width: 800px;
  margin: 0 auto 3rem;
  text-align: center;
`;

const SpecialOfferText = styled.div`
  background: linear-gradient(135deg, #f8f4e6, #faf6ed);
  border: 2px solid ${props => props.theme.colors.accent};
  border-radius: 12px;
  padding: 2rem;
  margin: 2rem auto;
  max-width: 600px;
  text-align: center;
  
  h3 {
    color: ${props => props.theme.colors.accent};
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }
  
  p {
    color: ${props => props.theme.colors.primary};
    font-size: 1.1rem;
    line-height: 1.6;
  }
`;

const ToursGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3rem;
  margin-top: 3rem;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const TourCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  
  &:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    border-color: ${props => props.theme.colors.accent};
  }
`;

const TourImage = styled.div`
  height: 300px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  position: relative;
  
  &::after {
    content: 'ADD TO BOOKING';
    position: absolute;
    top: 15px;
    right: 15px;
    background: ${props => props.theme.colors.accent};
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
  }
`;

const TourContent = styled.div`
  padding: 2rem;
`;

const TourTitle = styled.h3`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    color: ${props => props.theme.colors.accent};
  }
`;

const TourDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 2rem;
`;

const TourDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: ${props => props.theme.colors.greyBackground};
  border-radius: 8px;
`;

const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${props => props.theme.colors.primary};
  font-size: 1.1rem;

  svg {
    color: ${props => props.theme.colors.accent};
  }
`;

const PriceTag = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${props => props.theme.colors.accent};
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-weight: 600;
  margin-bottom: 1.5rem;
  position: relative;
  

`;

const BookButton = styled.a`
  display: inline-flex;
  align-items: center;
  background-color: ${props => props.theme.colors.accent};
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid ${props => props.theme.colors.accent};
  font-size: 1.1rem;
  
  &:hover {
    background-color: transparent;
    color: ${props => props.theme.colors.accent};
    transform: translateY(-2px);
  }
  
  svg {
    margin-left: 0.5rem;
  }
`;

const InfoBox = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.colors.greyBackground}, #f8f8f8);
  padding: 2rem;
  border-radius: 12px;
  margin-top: 4rem;
  text-align: center;
  border: 1px solid ${props => props.theme.colors.accent};
`;

const InfoText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
`;

const NewsletterTours = () => {
  return (
    <ToursContainer>
      <ParallaxBanner 
        title="Add Tours to Your Visit"
        subtitle="Enhance Your Castle Experience"
        image={banner}
      />
      
      <ContentContainer>
 
        <SectionTitle>Add Tours to Your Booking</SectionTitle>
        <IntroText>
          Thank you for booking your visit to Belvoir Castle! Enhance your experience by adding 
          our guided tours to your existing booking. Discover the rich history and fascinating 
          stories of Belvoir Castle through our expert-guided tours.
        </IntroText>
        
        <SpecialOfferText>
          <h3>🎯 Perfect Addition to Your Visit</h3>
          <p>
            Already have your tickets? Great! You can easily add these tours to your existing booking 
            for just £5 per person.
          </p>
        </SpecialOfferText>
        
        <ToursGrid>
          <TourCard>
            <TourImage image={castleTourImage} />
            <TourContent>
              <TourTitle>
                <FontAwesomeIcon icon={faClock} />
                Daily Castle Tours
              </TourTitle>
              <PriceTag>£5 per person</PriceTag>
              <TourDescription>
                Add this comprehensive castle tour to your visit! Join our expert guides for a tour of Belvoir Castle's 
                state rooms. Learn about the castle's history, architecture, and the fascinating stories of its inhabitants. 
                Perfect addition to your day out.
              </TourDescription>
              <TourDetails>
                <DetailItem>
                  <FontAwesomeIcon icon={faClock} />
                  <div>
                    <strong>Times:</strong><br />
                    11:00 & 14:00
                  </div>
                </DetailItem>
                <DetailItem>
                  <FontAwesomeIcon icon={faUsers} />
                  <div>
                    <strong>Duration:</strong><br />
                    1 ½ hours
                  </div>
                </DetailItem>
                <DetailItem>
                  <FontAwesomeIcon icon={faTicketAlt} />
                  <div>
                    <strong>Add-on Price:</strong><br />
                    £5 per person
                  </div>
                </DetailItem>
                <DetailItem>
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  <div>
                    <strong>Available:</strong><br />
                    Daily
                  </div>
                </DetailItem>
              </TourDetails>
              <BookButton 
                href="https://online1.venpos.net/VenposJourneyUI/?LocationId=978&Id=d6fce6a8-08aa-47d7-8fcc-f40bed0cd894" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Add Castle Tour <FontAwesomeIcon icon={faArrowRight} />
              </BookButton>
            </TourContent>
          </TourCard>

          <TourCard>
            <TourImage image={busTourImage} />
            <TourContent>
              <TourTitle>
                <FontAwesomeIcon icon={faBus} />
                Parkland Bus Tour
              </TourTitle>
              <PriceTag>£5 per person</PriceTag>
              <TourDescription>
                Add this scenic bus tour to your visit! Explore our stunning parkland designed by Capability Brown. 
                This guided tour takes you through the estate's beautiful landscape, offering unique views and 
                insights into the parkland's history and design.
              </TourDescription>
              <TourDetails>
                <DetailItem>
                  <FontAwesomeIcon icon={faClock} />
                  <div>
                    <strong>Times:</strong><br />
                    12:00, 13:30 & 15:00
                  </div>
                </DetailItem>
                <DetailItem>
                  <FontAwesomeIcon icon={faUsers} />
                  <div>
                    <strong>Duration:</strong><br />
                    1 hour
                  </div>
                </DetailItem>
                <DetailItem>
                  <FontAwesomeIcon icon={faTicketAlt} />
                  <div>
                    <strong>Add-on Price:</strong><br />
                    £5 per person
                  </div>
                </DetailItem>
                <DetailItem>
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  <div>
                    <strong>Available:</strong><br />
                    Thu - Sun
                  </div>
                </DetailItem>
              </TourDetails>
              <BookButton 
                href="https://online1.venpos.net/VenposJourneyUI/?LocationId=978&Id=d0493f69-a9d6-44ba-8552-334162e9861c" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Add Parkland Tour <FontAwesomeIcon icon={faArrowRight} />
              </BookButton>
            </TourContent>
          </TourCard>
        </ToursGrid>

        <InfoBox>
          <InfoText>
            <FontAwesomeIcon icon={faInfoCircle} /> Tours can be easily added to your existing booking for just £5 per person.
            Tours depart from the castle entrance and include expert commentary.
          </InfoText>
          <InfoText>
            <strong>Enhance your visit - add these tours to make the most of your day at Belvoir Castle!</strong>
          </InfoText>
        </InfoBox>

        {/* Featured Tours Upsell */}
        <SectionTitle style={{ marginTop: '4rem' }}>More Tour Options</SectionTitle>
        <IntroText>
          Looking for something different? Explore our specialised featured tours, including the Film Lover's Tour, 
          Art Collection Tour, and other unique experiences that can also be added to your visit. Please Note: These are only avail;able on selected days.
        </IntroText>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <BookButton href="/whats-on/featured-tours?newsletter=true">
            View Featured Tours <FontAwesomeIcon icon={faArrowRight} />
          </BookButton>
        </div>
      </ContentContainer>
      
      <Footer />
    </ToursContainer>
  );
};

export default NewsletterTours; 